<template>
  <PageLayout class="withdraw-requests-page">
    <Penalties />
  </PageLayout>
</template>

<script>
import Penalties from '../../views/penalties/index.vue';
import { PageLayout } from '@/shared/ui/layouts';
import { pages } from '@/entities/current-page';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: { PageLayout, Penalties },
  created() {
    this.changeActivePage(pages.PENALTIES);
  },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
  }
};
</script>

<style lang="scss" scoped>
::v-deep button {
  text-align: center;
}

::v-deep input {
    border: 1px solid #dde2e5 !important;
    border-radius: 3px !important;

    &:hover {
        border-color: #ffad3d !important;
    }
}

::v-deep .multiselect__input {
    border: none !important;
}
</style>
